<template>
    <span class="omni-alert omni-alert-inline">
        <BAlert v-bind="[$attrs, $props]">
            <span class="icon mr-2">
                <FontAwesomeIcon :icon="iconToShow" />
            </span>

            <span class="message">
                <slot>
                    {{ message }}
                </slot>
            </span>
        </BAlert>
    </span>
</template>

<script>
import Vue from 'vue';

/**
 * OmniAlertInline Component
 * Displays an inline alert message with optional icon. The alert variant (info, warning, error, etc.)
 * can be set to change the styling of the alert.
 */

export default Vue.extend({
    name: "OmniAlertInline",

    props: {
        /**
         * Whether or not to show the alert, defaults to true (overrides BootstrapVue)
         * @type {Boolean}
         */
        show: {
            type: Boolean,
            required: false,
            default: true
        },

        /**
         * The icon to display in the alert. If not provided, a default icon based on the
         * alert variant is used.
         * @type {String}
         */
        icon: {
            type: String,
            required: false
        },

        /**
         * The type of the alert (info, warning, error). This affects the default icon used in the component.
         * @type {String}
         */
        variant: {
            type: String,
            required: false,
            default: 'info'
        },
    },

    computed: {
        /**
         * Determines the icon to show in the alert. If the icon prop is set, it is used;
         * otherwise, a default icon based on the variant is used.
         * @returns {String} The icon class to be used.
         */
        iconToShow() {
            if (this.icon) {
                return this.icon;
            }

            switch(this.variant) {
                case 'info':
                    return 'info-circle';
                case 'warning':
                    return 'exclamation-triangle';
                case 'error':
                    return 'times-circle';
                default:
                    return 'info-circle';
            }
        }
    } 
})
</script>
